import { render, staticRenderFns } from "./DynamicEventPage.vue?vue&type=template&id=c2abdb1a&"
import script from "./DynamicEventPage.vue?vue&type=script&lang=js&"
export * from "./DynamicEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports